import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { useAuth } from './auth/useAuth';
import { peutOuvrirDossierOrganisation } from './lib/droits-repertoire';
import { LoginPage } from './pages/LoginPage';
import { EspaceCandidatPage } from './pages/EspaceCandidatPage';
import { MotDePasseOubliePage } from './pages/MotDePasseOubliePage';
import { ReinitialiserMotDePassePage } from './pages/ReinitialiserMotDePassePage';
import { ActivationComptePage } from './pages/ActivationComptePage';
import { DashboardPage } from './pages/DashboardPage';
import { AccessibilitePage } from './pages/AccessibilitePage';
import { AccesRefusePage } from './pages/AccesRefusePage';
import { AdmInscriptionsPage } from './pages/AdmInscriptionsPage';
import { LearnersPage } from './pages/LearnersPage';
import { AdmDossierPage } from './pages/AdmDossierPage';
import { AdmRupturesPage } from './pages/AdmRupturesPage';
import { AdmExportPage } from './pages/AdmExportPage';
import { BpfPage } from './pages/BpfPage';
import { AdmPiecesPage } from './pages/AdmPiecesPage';
import { AdmFormationsPage } from './pages/AdmFormationsPage';
import { AdmAntennesPage } from './pages/AdmAntennesPage';
import { AlertesPage } from './pages/AlertesPage';
import { ParcoursPage } from './pages/ParcoursPage';
import { ComEntreprisesPage } from './pages/ComEntreprisesPage';
import { ComEntretiensPage } from './pages/ComEntretiensPage';
import { AdmContratsApprentissagePage } from './pages/AdmContratsApprentissagePage';
import { AdmContratFormulairePage } from './pages/AdmContratFormulairePage';
import { ComMatchingPage } from './pages/ComMatchingPage';
import { ComCriteresMatchingPage } from './pages/ComCriteresMatchingPage';
import { ComRelancesPage } from './pages/ComRelancesPage';
import { PeriodeImmersionPage } from './pages/PeriodeImmersionPage';
import { PedSansContratPage } from './pages/PedSansContratPage';
import { PedRepertoirePage } from './pages/PedRepertoirePage';
import { RepertoireDossierPage } from './pages/RepertoireDossierPage';
import { EmargementPage } from './pages/EmargementPage';
import { PedAbsencesPage } from './pages/PedAbsencesPage';
import { PedIntegrationPage } from './pages/PedIntegrationPage';
import { PedSessionsPage } from './pages/PedSessionsPage';
import { PedIngenieriePage } from './pages/PedIngenieriePage';
import { SitesPage } from './pages/SitesPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { AppDocumentsPage } from './pages/AppDocumentsPage';
import { AppTimelinePage } from './pages/AppTimelinePage';
import { AppQuestionnairesPage } from './pages/AppQuestionnairesPage';
import { SatisfactionPage } from './pages/SatisfactionPage';
import { QuestionnairePublicPage } from './pages/QuestionnairePublicPage';
import { CataloguePage } from './pages/CataloguePage';
import { MesFormationsPage } from './pages/MesFormationsPage';
import { CalendrierPage } from './pages/CalendrierPage';
import { LecteurCoursPage } from './pages/LecteurCoursPage';
import { QuizPage } from './pages/QuizPage';
import { DevoirsPage } from './pages/DevoirsPage';
import { CertificatsPage } from './pages/CertificatsPage';
import { TuteurIaPage } from './pages/TuteurIaPage';
import { SupervisionIaPage } from './pages/SupervisionIaPage';
import { MessagesPage } from './pages/MessagesPage';
import { SettingsPage } from './pages/SettingsPage';
import { FacFormateursPage } from './pages/FacFormateursPage';
import { FormateursPage } from './pages/FormateursPage';
import { FacCircuitPage } from './pages/FacCircuitPage';
import { FacParametresPage } from './pages/FacParametresPage';
import { FinancementsPage } from './pages/FinancementsPage';
import { FacturesPage } from './pages/FacturesPage';
import { FormFichesPage } from './pages/FormFichesPage';
import { FormHeuresPage } from './pages/FormHeuresPage';
import { FormElearningPage } from './pages/FormElearningPage';
import { FormFacturationPage } from './pages/FormFacturationPage';
import { FormFinPage } from './pages/FormFinPage';
import { InstructorPromosPage } from './pages/InstructorPromosPage';
import { InstructorProgressionApprenantPage } from './pages/InstructorProgressionApprenantPage';
import { AbsenteismePage } from './pages/AbsenteismePage';
import { CHEMIN_ABSENTEISME, peutLireAbsenteisme } from './lib/useAbsenteisme';
import { InstructorCoursesPage } from './pages/InstructorCoursesPage';
import { InstructorCreatePage } from './pages/InstructorCreatePage';
import { InstructorAiGenPage } from './pages/InstructorAiGenPage';
import { InstructorGradingPage } from './pages/InstructorGradingPage';
import { InstructorStatsPage } from './pages/InstructorStatsPage';
import { DirAttributionsPage } from './pages/DirAttributionsPage';
import { DirUtilisateursPage } from './pages/DirUtilisateursPage';
import { InstructorQuizPage } from './pages/InstructorQuizPage';
import { DirVueGlobalePage } from './pages/DirVueGlobalePage';
import { DirApprenantsRisquePage } from './pages/DirApprenantsRisquePage';
import { DirApprenantsEntreprisesPage } from './pages/DirApprenantsEntreprisesPage';
import { ReclamationsPage } from './pages/ReclamationsPage';
import { AidePage } from './pages/AidePage';
import { DirParametresPage } from './pages/DirParametresPage';
import { DirPreinscriptionsPage } from './pages/DirPreinscriptionsPage';
import { DirConventionsPage } from './pages/DirConventionsPage';
import { DirModificationsPage } from './pages/DirModificationsPage';
import { DirJournalAuditPage } from './pages/DirJournalAuditPage';
import { DirSynthesesPage } from './pages/DirSynthesesPage';
import { PreinscriptionPublicPage } from './pages/PreinscriptionPublicPage';
import { QualiopiPage } from './pages/QualiopiPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { DirRapportsPage } from './pages/DirRapportsPage';
import { DirPilotageFinanceursPage } from './pages/DirPilotageFinanceursPage';
import { PedDocumentsPage } from './pages/PedDocumentsPage';
import { PedTestsPage } from './pages/PedTestsPage';
import { PedAccompagnementPage } from './pages/PedAccompagnementPage';
import { PedVeillePage } from './pages/PedVeillePage';
import { PedReportingPage } from './pages/PedReportingPage';
import { PedHubPage } from './pages/PedHubPage';
import { definitionEcran } from './config/ecrans';
import { EcranEnErreur } from './components/ui/Primitives';

function Chargement(): JSX.Element {
  return (
    <div className="flex min-h-screen items-center justify-center bg-codialis-cream">
      <div className="text-sm text-codialis-gray">Chargement de votre espace…</div>
    </div>
  );
}

/** Bloque l'accès à l'application aux sessions non authentifiées. */
function ZonePrivee(): JSX.Element {
  const { utilisateur, chargement } = useAuth();
  if (chargement) return <Chargement />;
  if (!utilisateur) return <Navigate to="/connexion" replace />;
  return <AppShell />;
}

/**
 * Écrans de l'espace apprenant : ils lisent le dossier du compte connecté. Un
 * autre profil qui les ouvre par leur adresse — la direction a tous les écrans —
 * n'y trouverait qu'une page vide ; il lit le dossier d'un apprenant depuis
 * « Apprenants ».
 */
const ECRANS_ESPACE_APPRENANT: ReadonlySet<string> = new Set([
  'app-documents',
  'app-timeline',
  'app-questionnaires',
  'mycourses',
  'assignments',
  'certificates',
]);

function EcranDeLApprenant({ ecran }: { ecran: string }): JSX.Element {
  return (
    <EcranEnErreur
      titre={definitionEcran(ecran)?.titre ?? 'Espace apprenant'}
      message="Cet écran est celui de l’apprenant connecté : il montre son propre parcours. Le dossier d’un apprenant se consulte depuis « Apprenants »."
    />
  );
}

/**
 * Aiguillage d'un écran de la maquette.
 * Les droits viennent de l'API ; le front n'a pas la matrice, il applique la
 * liste reçue. L'écran refusé affiche la page dédiée, sans redirection muette.
 */
function EcranRoute(): JSX.Element {
  const { ecran = '' } = useParams();
  const { peutAcceder, utilisateur } = useAuth();

  if (!definitionEcran(ecran)) return <Navigate to="/dashboard" replace />;
  if (!peutAcceder(ecran)) return <AccesRefusePage />;
  if (ECRANS_ESPACE_APPRENANT.has(ecran) && utilisateur?.profil !== 'APPRENANT') {
    return <EcranDeLApprenant ecran={ecran} />;
  }

  const ECRANS_LIVRES: Record<string, JSX.Element> = {
    dashboard: <DashboardPage />,
    accessibility: <AccessibilitePage />,
    help: <AidePage />,
    settings: <SettingsPage />,
    messages: <MessagesPage />,
    'adm-inscriptions': <AdmInscriptionsPage />,
    learners: <LearnersPage />,
    'adm-dossier': <AdmDossierPage />,
    'adm-ruptures': <AdmRupturesPage />,
    'adm-export': <AdmExportPage />,
    bpf: <BpfPage />,
    'adm-pieces': <AdmPiecesPage />,
    'adm-formations': <AdmFormationsPage />,
    'adm-contrats-apprentissage': <AdmContratsApprentissagePage />,
    'adm-antennes': <AdmAntennesPage />,
    alertes: <AlertesPage />,
    parcours: <ParcoursPage />,
    'com-entreprises': <ComEntreprisesPage />,
    'com-entretiens': <ComEntretiensPage />,
    'com-matching': <ComMatchingPage />,
    'com-matching-criteres': <ComCriteresMatchingPage />,
    'periode-immersion': <PeriodeImmersionPage />,
    'com-relances': <ComRelancesPage />,
    'ped-sanscontrat': <PedSansContratPage />,
    'ped-repertoire': <PedRepertoirePage />,
    emargement: <EmargementPage />,
    'ped-absences': <PedAbsencesPage />,
    'ped-integration': <PedIntegrationPage />,
    'ped-sessions': <PedSessionsPage />,
    'ped-ingenierie': <PedIngenieriePage />,
    sites: <SitesPage />,
    notifications: <NotificationsPage />,
    // Espace apprenant (CDC §8) et parcours e-learning.
    'app-documents': <AppDocumentsPage />,
    'app-timeline': <AppTimelinePage />,
    'app-questionnaires': <AppQuestionnairesPage />,
    satisfaction: <SatisfactionPage />,
    catalog: <CataloguePage />,
    mycourses: <MesFormationsPage />,
    calendar: <CalendrierPage />,
    player: <LecteurCoursPage />,
    quiz: <QuizIndexRoute />,
    assignments: <DevoirsPage />,
    certificates: <CertificatsPage />,
    'ai-tutor': <TuteurIaPage />,
    'ai-monitoring': <SupervisionIaPage />,
    // Espace formateur
    'form-fiches': <FormFichesPage />,
    'form-heures': <FormHeuresPage />,
    'form-elearning': <FormElearningPage />,
    'form-facturation': <FormFacturationPage />,
    instructors: <FormateursPage />,
    'form-fin': <FormFinPage />,
    'instructor-promos': <InstructorPromosPage />,
    'instructor-courses': <InstructorCoursesPage />,
    'instructor-create': <InstructorCreatePage />,
    'instructor-ai-gen': <InstructorAiGenPage />,
    'instructor-grading': <InstructorGradingPage />,
    'instructor-stats': <InstructorStatsPage />,
    // Espace facturation
    'fac-formateurs': <FacFormateursPage />,
    'fac-circuit': <FacCircuitPage />,
    'fac-parametres': <FacParametresPage />,
    financing: <FinancementsPage />,
    invoicing: <FacturesPage />,
    // Espace pédagogique
    'ped-hub': <PedHubPage />,
    'ped-documents': <PedDocumentsPage />,
    'ped-tests': <PedTestsPage />,
    'ped-accompagnement': <PedAccompagnementPage />,
    'ped-veille': <PedVeillePage />,
    'ped-reporting': <PedReportingPage />,
    // Espace direction
    'dir-attributions': <DirAttributionsPage />,
    'dir-utilisateurs': <DirUtilisateursPage />,
    'dir-vue-globale': <DirVueGlobalePage />,
    'dir-apprenants-risque': <DirApprenantsRisquePage />,
    'dir-apprenants-entreprises': <DirApprenantsEntreprisesPage />,
    'dir-preinscriptions': <DirPreinscriptionsPage />,
    'dir-conventions': <DirConventionsPage />,
    'dir-modifications': <DirModificationsPage />,
    'dir-journal': <DirJournalAuditPage />,
    'dir-syntheses': <DirSynthesesPage />,
    'dir-parametres': <DirParametresPage />,
    qualiopi: <QualiopiPage />,
    analytics: <AnalyticsPage />,
    'dir-rapports': <DirRapportsPage />,
    'dir-financeurs': <DirPilotageFinanceursPage />,
    // Réclamations (TF-482) : dépôt et suivi pour l'apprenant et le formateur, registre pour l'équipe.
    complaints: <ReclamationsPage />,
  };

  // Un écran de la maquette sans page n'affiche rien « en préparation » : il
  // renvoie au tableau de bord, comme un écran inconnu (TF-473).
  return ECRANS_LIVRES[ecran] ?? <Navigate to="/dashboard" replace />;
}

/**
 * Dossier d'un apprenant : même écran, avec l'identifiant dans l'URL.
 *
 * Trois écrans y mènent, comme côté API (`GET /api/apprenants/:id`) : le dossier
 * tenu par l'administratif, l'espace du candidat, et la consultation depuis
 * « Apprenants » pour le pédagogique et le formateur — le dossier est consultable
 * par tous les pôles impliqués, pour éviter les ressaisies. Le pôle facturation
 * l'a par « Dossiers apprenants » (TF-464), en lecture. La page n'ouvre ses
 * actions administratives qu'aux détenteurs de `adm-dossier`, et l'API refuse de
 * toute façon les écritures aux autres.
 */
function DossierRoute(): JSX.Element {
  const { peutAcceder } = useAuth();
  if (!peutAcceder('adm-dossier') && !peutAcceder('app-documents') && !peutAcceder('learners')) {
    return <AccesRefusePage />;
  }
  return <AdmDossierPage />;
}

/**
 * Dossier d'une organisation du répertoire : même convention que le dossier
 * apprenant, l'identifiant dans l'URL sous l'écran qui y mène.
 *
 * Deux chemins y conduisent : le répertoire commun (`ped-repertoire`), ouvert
 * à la relation entreprise, au recrutement et à l'administratif, et la
 * prospection (`com-entreprises`). L'écran n'ouvre la modification qu'à qui en
 * a le droit, et l'API refuse de toute façon l'écriture aux autres.
 */
function DossierOrganisationRoute(): JSX.Element {
  const { peutAcceder } = useAuth();
  if (!peutOuvrirDossierOrganisation(peutAcceder)) {
    return <AccesRefusePage />;
  }
  return <RepertoireDossierPage />;
}

/**
 * Fiche de progression d'un apprenant (TF-458), sous « Mes promotions » :
 * l'identifiant dans l'URL ; l'API ne la sert que pour un apprenant des
 * promotions du lecteur.
 */
function FicheProgressionRoute(): JSX.Element {
  const { peutAcceder } = useAuth();
  if (!peutAcceder('instructor-promos')) return <AccesRefusePage />;
  return <InstructorProgressionApprenantPage />;
}

/**
 * Taux d'absentéisme (TF-461), sous « Absences & avertissements » : le pôle
 * pédagogique y vient de son écran, l'administratif de l'émargement, la
 * direction de partout. L'API garde la route par profil.
 */
function AbsenteismeRoute(): JSX.Element {
  const { utilisateur } = useAuth();
  if (!peutLireAbsenteisme(utilisateur?.profil)) return <AccesRefusePage />;
  return <AbsenteismePage />;
}

/** Quiz d'un devoir précis : même écran que `quiz`, avec son identifiant dans l'URL. */
function QuizRoute(): JSX.Element {
  const { peutAcceder } = useAuth();
  if (!peutAcceder('quiz')) return <AccesRefusePage />;
  return <QuizPage />;
}

/**
 * Accès direct à `/quiz` sans identifiant (menu de navigation) : un quiz se
 * fait toujours pour un devoir précis, donc l'apprenant est renvoyé sur ses
 * devoirs pour en choisir un. Le formateur y lit « Quiz et exercices », les
 * quiz et devoirs de ses cours (la direction : tous). L'accès à l'écran `quiz`
 * lui-même est déjà vérifié par `EcranRoute`.
 */
function QuizIndexRoute(): JSX.Element {
  const { utilisateur } = useAuth();
  if (utilisateur?.profil === 'APPRENANT') return <Navigate to="/assignments" replace />;
  return <InstructorQuizPage />;
}

export function Router(): JSX.Element {
  return (
    <Routes>
      <Route path="/connexion" element={<LoginPage />} />
      <Route path="/mot-de-passe-oublie" element={<MotDePasseOubliePage />} />
      <Route path="/reinitialiser-mot-de-passe" element={<ReinitialiserMotDePassePage />} />
      {/* Ouverture de l'espace candidat : hors zone privée, le candidat n'a pas
          encore de compte — c'est ce qu'il vient créer. */}
      <Route path="/espace-candidat/:jeton" element={<EspaceCandidatPage />} />
      {/* Activation d'un compte invité par la direction : la personne n'a pas
          encore de mot de passe, c'est ce qu'elle vient choisir (TF-500). */}
      <Route path="/activer-compte/:jeton" element={<ActivationComptePage />} />
      {/* Questionnaire par le lien personnel du mail : sans session, il ne
          donne accès qu'à ce questionnaire. */}
      <Route path="/questionnaire/:jeton" element={<QuestionnairePublicPage />} />
      {/* Préinscription en ligne : le lien se partage à la main, le candidat
          n'a pas de compte (TF-429). */}
      <Route path="/preinscription" element={<PreinscriptionPublicPage />} />
      <Route element={<ZonePrivee />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/acces-refuse" element={<AccesRefusePage />} />
        <Route path="/adm-dossier/:id" element={<DossierRoute />} />
        <Route path="/learners/:id" element={<DossierRoute />} />
        <Route path="/ped-repertoire/:id" element={<DossierOrganisationRoute />} />
        <Route path="/adm-contrats-apprentissage/:immersionId" element={<AdmContratFormulairePage />} />
        <Route path="/quiz/:devoirId" element={<QuizRoute />} />
        <Route path="/instructor-promos/apprenants/:id" element={<FicheProgressionRoute />} />
        <Route path={CHEMIN_ABSENTEISME} element={<AbsenteismeRoute />} />
        <Route path="/:ecran" element={<EcranRoute />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
